import styled from 'styled-components';

import { RoundedCardContainer } from '../../../atoms/containers/RoundedCardContainer';
import { CurrencyDisplay, type CurrencyDisplayProps } from '../../currencyDisplay/CurrencyDisplay';
import { BaseAmountInput, type BaseAmountInputProps } from '../amount-input/BaseAmountInput';

export type BaseAmountSelectionInputProps = BaseAmountInputProps & CurrencyDisplayProps;

export const BaseAmountSelectionInput = ({
	altCurrencyAmount,
	currencyShortName,
	defaultCurrencyAmount,
	disabled,
	error,
	max,
	min,
	onChange,
	testID = 'amount-input',
	tooltipContent,
	value
}: BaseAmountSelectionInputProps) => {
	return (
		<S.Wrapper>
			<S.CurrencyAndDisplay>
				<CurrencyDisplay
					altCurrencyAmount={altCurrencyAmount}
					currencyShortName={currencyShortName}
					defaultCurrencyAmount={defaultCurrencyAmount}
					disabled={disabled}
				/>
				<BaseAmountInput
					disabled={disabled}
					error={error}
					max={max}
					min={min}
					showErrorMessage={false}
					testID={testID}
					tooltipContent={tooltipContent}
					value={value}
					onChange={onChange}
				/>
			</S.CurrencyAndDisplay>
			{error?.message && <S.ErrorMessage>{error.message}</S.ErrorMessage>}
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled(RoundedCardContainer)`
		flex-direction: column;
		padding: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const CurrencyAndDisplay = styled.div`
		display: flex;
		flex-wrap: wrap;
	`;

	export const ErrorMessage = styled.div`
		${({ theme }) => theme.fonts.text.text5};
		color: ${({ theme }) => theme.colors.borders.error.enabled};
		text-align: right;
		padding-top: ${({ theme }) => theme.spacings.xsmall};
	`;
}
